import application from 'application/application';

const controller = 'PrivacyPoliciesController';

application

	.controller(controller, [() => {}]);

export default controller;
